// material-ui
import Typography from '@mui/material/Typography';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import useAuth from 'hooks/useAuth';

import React from 'react';

// ===========================|| SIDEBAR MENU LIST ||=========================== //

const MenuList = () => {
    const { hasAnyRole } = useAuth();
    const isPermitted = hasAnyRole(['OPERATOR', 'ADMIN', 'TV_ARCHIVE', 'SUPERADMIN']);

    const navItems = menuItem(isPermitted).items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return navItems;
};

export default MenuList;
